import { StyleSheet } from 'aphrodite';
import { titles, white } from '../../../../../../web/styles/colors';
import { CssSelectors } from '../../../../../../web/styles/styles';

export const styleSheet = StyleSheet.create({
	header: {
		backgroundColor: white,
		paddingTop: 20,
		paddingBottom: 20,
		textAlign: 'center',
		...CssSelectors.allChildren(
			{
				color: titles,
				fontSize: 16,
				marginTop: 14,
			},
			':not(:first-child)'
		),
		minHeight: 110,
		alignItems: 'center',
		justifyContent: 'center',
		display: 'flex',
		flexDirection: 'column',
		flexShrink: 0,
	},
	heading: {
		fontSize: 24,
		margin: 0,
	},
	logo: {
		width: '100%',
		maxWidth: 200,
	},
});
